<template>
    <div class="product-selector-main">       
        <transition name="fade" mode="out-in">
            <div class="product-selector-header" :key="current" :class="{'is-results': current.products}">
                <span class="tagline text-cod-gray">
                    <figure class="text-blue-stone">
                        <span class="inline-svg" style="padding-top: 141.67%">
                            <tagline />
                        </span>
                    </figure>
                    Product Selector
                </span>
                
                <h2 class="md-title text-cod-gray" v-if="current.question">{{ current.question }}</h2>
                <h2 class="md-title text-cod-gray" v-if="current.products">Thank you! We suggest the following product based upon your answers.</h2>
            </div>
        </transition>
        
        <transition name="fade" mode="out-in">
            <ValidationObserver tag="div" ref="observer" :key="current" v-if="current.answers">
                <ValidationProvider tag="div" rules="required" v-slot="{ errors }" class="columns is-multiline is-variable is-8-mobile is-8-tablet is-4-desktop">

                    <template v-for="(answer, index) in current.answers">
                        <div class="column is-full-mobile is-full-tablet is-full-desktop capped" v-if="!answer.image" :key="index">
                            <label class="product-selector-item">
                                <input type="radio" :name="current.question" :value="index" v-model="pick" />
                                <h5 class="xxs-title text-cod-gray" v-text="answer.title" />
                            </label>
                        </div>

                        <div class="column is-full-mobile is-6-tablet is-3-desktop" v-if="answer.image" :key="index">
                            <label class="product-selector-option">
                                <input type="radio" :name="current.question" :value="index" v-model="pick" />
                                <div class="product-selector-card">
                                    <h3 v-text="answer.title" class="text-cod-gray xxs-title" />
        
                                    <div class="product-selector-card-image">
                                        <img :src="`${path}${answer.image}`" class="object-cover-absolute" alt="card image" />
                                    </div>
                                </div>
                            </label>
                        </div>
                    </template>

    
                    <div class="column is-full-mobile is-full-tablet">
                        <span class="is-danger" v-if="errors[0]">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </transition>
        
        <transition name="fade" mode="out-in">
            <div :key="current">
                <div id="product-grid" class="product-grid-container text-left" v-if="current.products">
                    <div class="columns is-multiline is-mobile is-variable is-3-mobile is-6-tablet is-6-desktop">
                        <div class="column is-6-mobile is-6-tablet is-4-desktop" v-for="(product, index) in products" :key="index" v-html="product.outerHTML">
                        </div>
                    </div>
                </div>

                <div class="product-selector-button">
                    <a @click.prevent="prev" class="btn btn-primary text-cod-gray" aria-label="Go backwards" v-if="steps.length > 1">
                        <figure class="btn-icon text-blue-stone">
                            <span class="inline-svg" style="padding-top: 100%;transform:rotate(180deg);left:-10px;">
                                <button-arrow />
                            </span>
                        </figure>
                        <span class="btn-text">Go Backwards</span>
                    </a>
    
                    <a href="/pages/product-selector" v-if="steps.length > 1" class="btn btn-primary text-cod-gray" aria-label="Start Again">
                        <figure class="btn-icon text-blue-stone">
                            <span class="inline-svg" style="padding-top: 100%;transform:rotate(180deg);left:-10px;">
                                <button-arrow />
                            </span>
                        </figure>
                        <span class="btn-text">Start Again</span>
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import buttonMixin from '~/mixins/buttonMixin'
import axios from 'axios'
export default {
    mixins: [buttonMixin],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data: () => ({
        products: [],
        pick: "",
        headerOffset: 0,
    }),
    computed: {
        path() {
            return window.__webpack_public_path__
        },
        steps() {
            return this.$store.state.productSelector.steps
        },
        current() {
            return this.steps.slice(-1)[0]
        }
    },
    mounted() {
        this.headerOffset = this.$el.querySelector('.product-selector-header').getBoundingClientRect().top + window.scrollY - 100
    },
    watch: {
        pick: {
            handler: "next"
        }
    },
    methods: {
        async next() {
            console.log('next fired')
            const valid = await this.$refs.observer.validate()
            
            if (!valid || this.pick == null) {
                return
            }
            
            const next = this.current.answers[this.pick]

            // If products exist in next step, call product fetch.
            if (next.products) {
                this.fetchProducts(next.products)
            }

            // Add next step to array.
            this.$store.commit('productSelector/ADD_STEP', next)

            // Reset active pick.
            this.pick = null
            
            window.scrollTo({
                top: this.headerOffset,
                left: 0,
                behavior: 'smooth'
            })
        },
        prev() {
            // Remove last step from array.
            this.$store.commit('productSelector/REMOVE_STEP')

            // Remove footer class on introduction page.
            if (!this.steps.length) {
                const footer = document.querySelector('.site-footer')
                footer.classList.remove('site-footer--product-selector')
            }

            // Reset active pick.
            this.pick = null

            window.scrollTo({
                top: this.headerOffset,
                left: 0,
                behavior: 'smooth'
            })
        },
        fetchProducts(products) {
            if (!products.length) {
                return
            }

            // Clear products.
            this.products = []

            // Loop over each product handle and fetch product card via Section Rendering API.
            products.forEach((product) => {
                axios.get('/products/' + product.handle + '?variant=' + product.variant + '&section_id=render-product').then((response) => {
                    const card = new DOMParser().parseFromString(response.data, 'text/html').querySelector('.product-card')

                    this.products.push(card)
                })
            })
        },
    }
}
</script>
